import styled from "styled-components"

export const Footer = styled.footer`
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    background-color: var(--principal-color);
`